import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  save() {
    const form = this.element.closest("form") || this.element.querySelector("form")
    form?.requestSubmit()
  }
}
